// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"ad8a9a3fbc48e1d10bb1","310":"a98c8e3d03432095a2f5","926":"3b2ffea26e1251e3e8ae"}[chunkId] + ".chunk.js";
};